module.exports = __webpack_public_path__ + "img/logo2.cbfa77c8.png";